import React, { useCallback, useState } from 'react'
import classNames from 'classnames'
import Path from '@leverege/path'
import { Button, TextInput, Dialog, Dialogs } from '@leverege/ui-elements'
import GroupAttributeView from './GroupAttributeView'

import S from './style.css'

export default function MapGroupAttributeView( props ) {
  const { node, deviceData, onSetValue } = props
  const path = node.path.substring( 0, node.path.length - 1 )
  const [ newKey, setNewKey ] = useState( null )
  const [ opened, setOpened ] = useState( true )
  const [ created, setCreated ] = useState( [] )

  const onClear = useCallback( ( e ) => {
    const onClose = Dialogs.show( {
      component : Dialog.Question,
      props : {
        title : 'Delete All Fields in Group',
        okay : 'Delete All',
        message : `Are you sure you want to delete ALL fields under "${path}"?`,
        onOkay : ( e ) => {    
          onSetValue( { attribute : null, path, value : null } )
          setCreated( [] )      
          onClose()
        }, 
        onCancel : () => { onClose() }
      }
    } )

  }, [ path, onSetValue, setCreated ] )

  const v = Path.get( path, deviceData, {} )

  const onDelete = useCallback( ( e ) => {
    if ( created.indexOf( e.data ) >= 0 ) {
      setCreated( created.filter( k => k !== e.data ) )
    } 
  }, [ created, setCreated ] )
 
  const rtn = []
  const keys = Object.keys( v || {} )
  if ( v != null ) {
    created.forEach( ( k ) => {
      if ( v[k] == null ) {
        keys.push( k )
      }
    } )
    for ( let i = 0; i < keys.length; i++ ) {
      const cNode = { ...node, name : keys[i], path : `${path}/${keys[i]}` }
      rtn.push( (
        <GroupAttributeView {...props} node={cNode} key={keys[i]} onDelete={onDelete} eventData={keys[i]}/>
      ) )
      rtn.push( <div key={`div-${i}`} className={S.grpAttrDiv} /> )
    }
  }
  let name = node.name
  if ( name[name.length - 1] === '@' ) {
    name = name.slice( 0, -1 )
  }

  const newKeyChange = useCallback( ( e ) => {
    const val = e.value?.trim()
    if ( val.length > 0 && created.indexOf( val ) < 0 ) {
      setCreated( () => [ ...created, val ].filter( k => v[k] === undefined ) )      
      setNewKey( null )
    } 
  }, [ created, v, setCreated ] )

  return (
    <div className={S.grpAttrSpanView}>
      <div className={S.flex}>
        <div className={S.attrViewLabel}>
          <Button 
            variant="link"
            style={{ padding : '0px' }}
            icon={opened ? 'fa fa-caret-down fa-fw' : 'fa fa-caret-right fa-fw'} 
            onClick={() => setOpened( !opened )} />
          <span className={S.attrLabel}>{name}</span>
          <span className={S.attrArrow}>&rarr;</span>
          <span className={S.attrArrow}>&#123;</span>
          { !opened && <span className={S.attrArrow}>&nbsp;&#125;</span> }
        </div>
        <div className={S.flexRight}>
          <div className={S.attrViewPath}>{path}</div>
          <Button 
            variant="link"
            icon="fa fa-times fa-fw" 
            disabled={keys.length === 0}
            eventData={node.path}
            onClick={onClear} />
        </div>
      </div>
      <div className={classNames( S.grpAttrView, S.grpAttrNested )} >
        {opened && rtn}
        { opened && (
          <TextInput 
            variant="attrKey"
            hint="Add Key..." 
            acceptKey={validateKey}
            value={newKey} 
            onChange={newKeyChange} />
        ) }
      </div>
      
      { opened && <div className={S.attrViewLabel}><span className={S.attrArrow}>&#125;</span></div> }

    </div>
  )
}

const RX = /^[a-zA-Z0-9_]+$/
function validateKey( e ) {
  return RX.test( e.key )
}
